import { defineStore } from "pinia";
import { CirrusDefaultConfig } from "../shared/CirrusDefaultConfig";
import type { LatestConfig } from "../../../../app/configuration/schemas";

interface CirrusConfigState {
  config: LatestConfig,
}
export const useCirrusConfigStore = defineStore('cirrusConfig', {
  state: (): CirrusConfigState => ({
    config: CirrusDefaultConfig,
  }),
  actions: {
    hideReflowableConfigSettings(){
      if (this.config && this.config.public.settings){
        this.config.public.settings.fontFamily = { enabled: false, value: '' };
        this.config.public.settings.fontSize = { enabled: false, value: '' };
        this.config.public.settings.ignoreAspectRatio = { enabled: false, value: false };
        if (this.config.plan == "pro"){
          this.config.public.settings.letterSpacing = { enabled: false, value: '' };
          this.config.public.settings.lineHeight = { enabled: false, value: '' };
          this.config.public.settings.wordSpacing = { enabled: false, value: '' };
        }
      }
    }
  }
});